import React from "react";
import { MessageCircle, HeartHandshake, Sparkles } from "lucide-react";
import PainLandingPage from "@/pages/PainLandingPage";

const AfterAFightPage = () => (
  <PainLandingPage
    ns="afterAFight"
    variant="gold"
    photo="/assets/lifestyle/couple-interlude.jpg"
    icons={[<MessageCircle size={20} />, <HeartHandshake size={20} />, <Sparkles size={20} />]}
  />
);

export default AfterAFightPage;
